import { DealSummaryContainer } from '../DealSummary.interstate.style';
import { ExpandableAreaProvider, InterstateDealSummarySections, DealSummaryProvider } from '@makemydeal/dr-dash-components';
import DealRecap from './DealRecap.interstate';

const DealRecapSummary = ({ showDetailedView = false, scopeId }: { showDetailedView?: boolean; scopeId?: string }) => {
    const Provider = showDetailedView ? DealSummaryProvider : ExpandableAreaProvider;
    return (
        <Provider {...(showDetailedView ? { showDetailedView } : {})}>
            <DealSummaryContainer data-testid="deal-recap-container" xs={3.9} width="100%" $isCompactView={!showDetailedView}>
                {!showDetailedView ? (
                    <InterstateDealSummarySections.InterstateDetails scopeId={scopeId}>
                        <DealRecap />
                    </InterstateDealSummarySections.InterstateDetails>
                ) : (
                    <DealRecap />
                )}
            </DealSummaryContainer>
        </Provider>
    );
};

export default DealRecapSummary;
